import React from 'react';
import PropTypes from 'prop-types';
import EditableRichText from '../../../../src/web/containers/EditableRichText';

const propTypes = {
  id: PropTypes.string,
  isEditing: PropTypes.bool,
  onCancelEdit: PropTypes.func,
  onFinishEdit: PropTypes.func,
  rawContentState: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

const defaultProps = {
  id: undefined,
  isEditing: undefined,
  onCancelEdit: undefined,
  onFinishEdit: undefined,
  rawContentState: undefined,
};

const DirectionsText = ({
  id,
  isEditing,
  onCancelEdit,
  onFinishEdit,
  rawContentState,
}) => (
  <EditableRichText
    editorKey={id}
    editing={isEditing}
    onSave={onFinishEdit}
    rawContentState={rawContentState}
    onDismiss={onCancelEdit}
  />
);

DirectionsText.propTypes = propTypes;
DirectionsText.defaultProps = defaultProps;

export default DirectionsText;
